import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Notifications from "../helpers/toast-notifications";
import i18n from "../i18n";
import router from "../router";

Vue.use(Vuex);

function getServerDomain() {
  const origin = window.location.origin;
  if (origin.includes("localhost") || origin.includes("127.0.0.1")
     || origin.includes("192")
    ) {
    let url = origin.replace("http://localhost:8080","https://demo.inventive-dev.com");
    return "https://rayan-back.incentive-dev.com";
  } 
 else
  if(origin.includes("kareem-alsham") || origin.includes("lbbis") || origin.includes("sana-poetic")) {
   return origin.replace(".incentive-dev.com","-back.incentive-dev.com");
  }
  else {
   return "https://rayan-back.incentive-dev.com";
  }
}

function getServerDomainApi() {
  return getServerDomain() + "/api";
}

export default new Vuex.Store({
  state: {
    showOTPModal: false,
    serverDomain: "https://rayan-back.incentive-dev.com",
    serverDomainApi: "https://rayan-back.incentive-dev.com/api",
    barImage: "",
    appBarFire: true,
    drawer: true,
    userData: {
      username: "",
      abilities: [],
    },
    termModel: [],
    drawerList: [],
    schSetting: {
      SYSTEM_NAME: 'Incentive',
      COIN_CODE: '€',
      COIN_NAME: 'Euro',
      // SYSTEM_IMAGE: require("@/assets/Logo 2.png"),
    },
    websiteSettings: null, 
    activeDash: true,
    routeNameAddition: "", 
    isDarkMode: false,
    acTapHrIn: 0,
    tabRoute: 0,
    tabTrip: 0,
    tabAi: 0,
    tabWorkFlow: 0,
    tabTeachers: 0,
    studentTap: 0,
  },
  mutations: {
    SET_OTP_MODAL(state, show) {
      state.showOTPModal = show
    },
    SET_WEBSITE_SETTINGS(state, data) {
      state.websiteSettings = data
    },
    SET_DRAWER_LIST(state, payload) {
      state.drawerList = payload;
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_ACTIVE_DASH(state, payload) {
      state.activeDash = payload;
    },
    setUserData(state, userInfo) {
      state.userData.username = userInfo.user_data.user_name;
      state.userData.abilities = userInfo.abilities;
    },
    setTermModel(state, payload) {
      state.termModel = payload;
    },
    setRouteNameAddition(state, addition) {
      state.routeNameAddition = addition;
    },
    SET_DARK_MODE(state, payload) {
      state.isDarkMode = payload;
    },
    SET_ACTABHRIN(state, payload){
      state.acTapHrIn = payload;
    },
    SET_TABROUTE(state, payload){
      state.tabRoute = payload;
    },
    SET_TABTRIP(state, payload){
      state.tabTrip = payload;
    },
    SET_TABAI(state, payload){
      state.tabAi = payload;
    },
    SET_TABWORKFLOW(state, payload){
      state.tabWorkFlow = payload;
    },
    SET_TABTEACHERS(state, payload){
      state.tabTeachers = payload;
    },
    SET_studentTab(state, payload){
      state.studentTap = payload;
    },
  },
  actions: {
    showOTPModal({ commit }) {
      commit('SET_OTP_MODAL', true)
    },
    hideOTPModal({ commit }) {
      commit('SET_OTP_MODAL', false)
    },
    async userLogin({ commit, dispatch  }, userData) {
      try {
        const logInResponse = await axios.post("/auth/login", {
          username: userData.username,
          password: userData.password,
        });
        console.log("login response", logInResponse);
        commit("setUserData", logInResponse.data.data);
        localStorage.setItem("user_data",JSON.stringify(logInResponse.data.data));
        localStorage.setItem("access_token",logInResponse.data.data.access_token);
        axios.defaults.headers.common["Authorization"] = "Bearer " + logInResponse.data.data.access_token;
        Notifications( i18n.t("login success"),{ timeout: 1000, rtl: true },"success");
        router.replace("/");
      } catch (err) {
      } finally {
      }
    },
    autoLogIn({ commit }) {
      commit( "setUserData", JSON.parse( localStorage.getItem("user_data") ) );
      axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("access_token");
    },
  },
  getters: {
    getUserName(state) {
      return state.userData.username;
    },
    getUserAbilities(state) {
      return state.userData.abilities;
    },
    getRouteNameAddition(state) {
      return state.routeNameAddition;
    },
  },
  modules: {
  },
});
